import { Record } from 'immutable';

interface AuthenticationState {
  isAuthenticated: boolean;
}

export const initialState: AuthenticationState = {
  isAuthenticated: true
};

export default class Authentication extends Record(initialState) {
}
